import React from 'react';
import GameModal from '../../components/GameModal/GameModal.tsx';
import SubtextWordsList from '../../components/shared/SubtextWordsList.tsx';

interface SubtextWordsModalProps {
  foundWords: string[];
  isOpen: boolean;
  onClose: () => void;
  longestSubWordLength?: number;
}

export default function SubtextWordsModal({ foundWords, isOpen, onClose, longestSubWordLength }: SubtextWordsModalProps) {
  const modalContent = (
    <div className="subtext-words-modal-content">
      <SubtextWordsList words={foundWords} longestSubWordLength={longestSubWordLength} />
    </div>
  );
  
  const titleText = `You have found ${foundWords.length} word${foundWords.length !== 1 ? 's' : ''}`;
  
  const titleStyle: React.CSSProperties = {
    fontSize: '18px',
    fontWeight: '600',
  };
  
  return (
    <GameModal
      title={titleText}
      titleStyle={titleStyle}
      content={modalContent}
      isOpen={isOpen}
      onClose={onClose}
    />
  );
} 